import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import { windowSizeChange, setRoute } from "../../store/helpers";
import { carousel, filters } from "../../store";
import { Routes } from "../../components";

class App extends Component {
	// state = {
	// 	search: ""
	// }

	componentDidMount() {
		this.props.windowSizeChange(this.props.window.width);
		window.addEventListener("resize", this.props.windowSizeChange);
		// this.props.fetchMedia();
		// FileSaver.saveAs("http://sogeprom.immo-lead.com/appli/uploads/mediaprg/19/100247/101332-07.4-b32-bas-haut.pdf", "fileSaver.pdf");
		// this.setState({ search: this.props.location.search });
	}

	// componentDidUpdate (props, state) {}

	componentWillUnmount() {
		window.removeEventListener("resize", this.props.windowSizeChange);
	}

	render() {
		return <Routes />;
	}
}

const mapStateToProps = state => ({
	...state.helpers,
	isAuthenticated: state.auth.isAuthenticated,
	filters: state.filters
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			windowSizeChange,
			setRoute,
			fetchMedia: carousel.fetchMedia,
			setFilters: filters.setFilters,
			setUrlQuery: filters.setUrlQuery
		},
		dispatch
	);

App.propTypes = {
	history: PropTypes.object.isRequired,
	setRoute: PropTypes.func.isRequired,
	window: PropTypes.object.isRequired,
	windowSizeChange: PropTypes.func.isRequired
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(App)
);
